export const MENBERS_LIST = "MENBERS_LIST";
export const GET_CITIES = "GET_CITIES";
export const MEMBER_DETAILS = "MEMBER_DETAILS";
export const SET_FILTERS_OPTIONS = "SET_FILTERS_OPTIONS";
export const SET_MEMBERS_SEARCH_OPTIONS = "SET_MEMBERS_SEARCH_OPTIONS";
